import { Route, Router, useLocation } from "@solidjs/router";
import { createEffect, on, type JSX } from "solid-js";
import { Account } from "./screens/Account";
import { Activate } from "./screens/Activate";
import { History } from "./screens/History";
import { Home } from "./screens/Home";
import { Itinerary } from "./screens/Itinerary";
import { MapScreen } from "./screens/MapScreen";
import { Payment } from "./screens/Payment";
import { Phone } from "./screens/Phone";
import { Prices } from "./screens/Prices";
import { Receipt } from "./screens/Receipt";
import { Ride } from "./screens/Ride";
import { Scan } from "./screens/Scan";
import { Report } from "./screens/Report";
import { Search } from "./screens/Search";
import { SignIn } from "./screens/SignIn";
import { Start } from "./screens/Start";
import { Stub } from "./screens/Stub";
import { Trip } from "./screens/Trip";

/**
 * Every screen starts at the top. iOS Safari may leave the page scrolled (keyboard on the scan's
 * manual entry, camera view), which shifted fixed-height screens like the map and showed a band.
 */
function ScrollReset(props: { children?: JSX.Element }) {
  const location = useLocation();
  createEffect(
    on(
      () => location.pathname,
      () => window.scrollTo(0, 0),
    ),
  );
  return props.children;
}

export function App() {
  return (
    <div class="app-shell mx-auto max-w-[430px] bg-surface shadow-[0_0_0_1px_#e0e0e0]">
      <Router root={ScrollReset}>
        <Route path="/" component={Home} />
        <Route path="/signin" component={SignIn} />
        <Route path="/start" component={Start} />
        <Route path="/map" component={MapScreen} />
        <Route path="/activate" component={Activate} />
        <Route path="/payment" component={Payment} />
        <Route path="/phone" component={Phone} />
        <Route path="/scan" component={Scan} />
        <Route path="/ride" component={Ride} />
        <Route path="/trip/:id" component={Trip} />
        <Route path="/account" component={Account} />
        <Route path="/tarifs" component={Prices} />
        <Route path="/recherche" component={Search} />
        <Route path="/itineraire" component={Itinerary} />
        <Route path="/signaler" component={Report} />
        <Route path="/historique" component={History} />
        <Route path="/historique/:id" component={Receipt} />
        <Route path="*" component={() => <Stub title="Page introuvable" />} />
      </Router>
    </div>
  );
}
